module.exports = __webpack_public_path__ + "static/img/jihuo.272ff70f.png";